import { Subscription } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageBrokerService } from '../core/message-broker.service'
import { ErrorModel } from '../core/index';
import { Observable } from 'rxjs';


@Component({
  selector: 'error',
  standalone: false,
  templateUrl: './error.component.html'
})
export class ErrorComponent implements OnInit {
  error: ErrorModel = new ErrorModel();
  constructor(public route: ActivatedRoute, private _router: Router, private _messageBrokerService: MessageBrokerService) { }
  public ngOnInit() {
    this.subScribeErrorChanges();
  }
  reloadPage(): void {
    if (!this.error.shouldRefreshApp) {
      if (this.error.reloadRoute)
        this._router.navigateByUrl(this.error.reloadRoute);

      if (location.href.endsWith('error')) {
        this._router.navigateByUrl('/');
        return;
      }

      location.reload();
    }
    else {
      //the following forces the app to reload
      window.location.hash = "";  
      window.location.reload();
    }

  }
  ngOnDestroy() {
    if (this.errorSubscription){
      this.errorSubscription.unsubscribe();

    }
  }

  errorSubscription: Subscription;

  subScribeErrorChanges(): void {
    this.errorSubscription = this._messageBrokerService.getError().subscribe((error: ErrorModel) => {
      // console.error('ErrorComponent.subScribeErrorChanges():' + error);
      console.error('ErrorComponent.subScribeErrorChanges():' + JSON.stringify(error));
      if (error != null) {
        this.error = error;
      }
    });
  }
}
